import * as React from 'react';

const blogIconSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="4" fill="white" />
    <rect
      x="2"
      y="1"
      width="16"
      height="8"
      rx="1"
      fill="url(#paint0_linear_23111_757)"
    />
    <rect
      x="2"
      y="10"
      width="16"
      height="2"
      rx="0.557049"
      fill="url(#paint1_linear_23111_757)"
    />
    <rect
      x="2"
      y="13"
      width="16"
      height="2"
      rx="0.557049"
      fill="url(#paint2_linear_23111_757)"
    />
    <rect
      x="2"
      y="16"
      width="13"
      height="2"
      rx="0.557049"
      fill="url(#paint3_linear_23111_757)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_23111_757"
        x1="15.4815"
        y1="7.774"
        x2="1.50548"
        y2="-3.15231"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_23111_757"
        x1="13.7647"
        y1="11.4762"
        x2="12.6103"
        y2="5.87215"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_23111_757"
        x1="13.7647"
        y1="14.4762"
        x2="12.6103"
        y2="8.87215"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_23111_757"
        x1="11.5588"
        y1="17.4762"
        x2="10.1672"
        y2="11.9872"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDD1E7" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);

export default blogIconSmall; 
